import * as R from 'ramda'
import { distinctUntilChanged } from 'rxjs/operators'
import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { queryFromString } from 'helpers/url'
import { getQuery } from 'store/selectors'

// type AwaitForPageChanged = ActionsObservable => ActionsObservable
export const awaitForPageChanged = actions$ => {
  const locationChange$ = actions$.pipe(ofType(LOCATION_CHANGE))
  return locationChange$.pipe(
    distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname'])))
  )
}

export const isSamePage = (locationChangeAction, state) => { // (locationChangeAction: LocationChangeAction, state: StateObservable)
  const locationChangeKey = queryFromString(locationChangeAction.payload.location.search).key
  const currentKey = getQuery(state).key

  return locationChangeKey === currentKey
}
